{
  "instances": {
    "caches": {
      "label": "缓存",
      "cache_manager": "缓存管理",
      "loading": "加载缓存中...",
      "name": "名称",
      "no_caches_found": "未找到缓存。"
    }
  }
}
